module.exports = __webpack_public_path__ + "7990c8114875d60a0e0c6920de38d7be.svg";